import React from 'react';
import { IonSearchbar } from '@ionic/react';
import styles from './styles.module.scss';

type IonSearchBarProps = React.ComponentProps<typeof IonSearchbar>;

export const CustomSearchBar: React.FC<IonSearchBarProps> = ({ className, ...rest }) => {
	return <IonSearchbar mode="ios" className={`${styles.searchBarSty} ${className}`} clearIcon={undefined} {...rest} />;
};
